import React, { ReactComponentElement } from 'react'

import { Content, ContentBody, ModalComponent, TitleHeader } from './styles'
import useIsMobile from '../../../hooks/useIsMobile'
import { ButtonIcon } from '../../Table/Pagination/styles'
import { FaXmark } from 'react-icons/fa6'

export interface ModalHandle {
  openModal: () => void
  closeModal: () => void
}

export interface ModalProps {
  title?: string
  maxWidth?: number
  isLarge?: boolean
  onOpenModal?: () => void
  children?: React.ReactNode
}

const Modal: React.ForwardRefRenderFunction<ModalHandle, ModalProps> = (
  { title, onOpenModal, maxWidth = 500, isLarge, children },
  ref,
) => {
  const isMobile = useIsMobile()

  const [open, setOpen] = React.useState(false)

  React.useImperativeHandle(ref, () => ({
    openModal() {
      setOpen(true)
    },
    closeModal() {
      setOpen(false)
    },
  }))

  const afterOpenModal = () => {
    if (onOpenModal) {
      onOpenModal()
    }
  }
  return (
    <ModalComponent
      isOpen={open}
      //@ts-ignore
      maxWidth={maxWidth}
      isLarge={isLarge}
      onAfterOpen={afterOpenModal}
      onRequestClose={() => setOpen(false)}
      contentLabel='Example Modal'
    >
      <Content maxWidth={maxWidth}>
        {title && <TitleHeader>{title}</TitleHeader>}
        <ButtonIcon onClick={() => setOpen(false)}>
          <FaXmark size={25} />
        </ButtonIcon>
      </Content>
      <ContentBody>{children}</ContentBody>
    </ModalComponent>
  )
}

export default React.forwardRef(Modal)
